<script>
  import Hero from "../Hero.svelte";
  import Slide from "../Slide.svelte";
  import Conclusion from "../Conclusion.svelte";

  export let data;
  export let years;

  import "swiper/css/navigation";

  import { Swiper, SwiperSlide } from "swiper/svelte";
  import SwiperCore, {
    Keyboard,
    Mousewheel,
    FreeMode,
    Scrollbar,
    Navigation,
    HashNavigation,
  } from "swiper";

  SwiperCore.use([
    Keyboard,
    Mousewheel,
    FreeMode,
    Scrollbar,
    Navigation,
    HashNavigation,
  ]);

  let activeYear = null;
  const slideWidth = 150;

  import { currentYear, isSafari } from "../../stores/global.js";

  let freeModeActive = false;
  let cssModeActive = false; // true fixes performance and then leads to rendering issues

  // We want to prerender titles for the slides surrounding the active year
  $: index = years.indexOf(activeYear);
  $: shouldRenderTitlesFor = function (year) {
    return years
      .slice(Math.max(index - 1, 0), index + 2) // Don't slice with a negative index
      .includes(year);
  };

  // No matter the window width, allow for touch interactions on touchscreen devices
  import { detectTouchscreen } from "../../scripts/utils.js";
  let isTouchscreen = detectTouchscreen();
</script>

<div id="desktop-layout">
  <Swiper
    modules={[
      Keyboard,
      Mousewheel,
      FreeMode,
      Scrollbar,
      HashNavigation,
      Navigation,
    ]}
    keyboard
    navigation
    scrollbar={{
      hide: false,
      draggable: true,
    }}
    hashNavigation={{
      watchState: true,
      replaceState: true,
    }}
    freeMode={{
      enabled: freeModeActive,
      momentum: false,
      sticky: false,
      momentumBounce: false,
    }}
    watchSlidesProgress={true}
    watchSlidesVisibility={true}
    centeredSlides={true}
    slidesPerView={"auto"}
    spaceBetween={0}
    cssMode={cssModeActive}
    allowTouchMove={isTouchscreen}
    grabCursor={false}
    speed={600}
    preventInteractionOnTransition={true}
    followFinger={true}
    edgeSwipeDetection={"prevent"}
    mousewheel={{
      thresholdDelta: $isSafari ? 15 : 10, // Required scroll intensity to continue
      thresholdTime: $isSafari ? 900 : 800, // How often to acknowledge a new scroll
    }}
    on:slideChange={(e) => {
      activeYear = years[e.detail[0][0].activeIndex - 1]; // ! Decrement this according to how many 'starting' slides there are
      currentYear.set(activeYear);
    }}
  >
    <SwiperSlide class="first" data-hash=""><Hero /></SwiperSlide>
    {#each years as year, index}
      <Slide
        data={data.filter((d) => d.year == year)}
        even={index % 2 == 0 ? true : false}
        width={slideWidth}
        slideIsActive={activeYear == year}
        shouldRenderTitles={true}
        {year}
      />
    {/each}
    <SwiperSlide class="last" data-hash="conclusion"><Conclusion /></SwiperSlide
    >
  </Swiper>
</div>

<style>
  :global(#desktop-layout .swiper-button-prev, #desktop-layout
      .swiper-button-next) {
    top: 3% !important;
    color: white !important;
    padding: 0.5rem;
  }

  :global(.swiper-button-disabled) {
    opacity: 0 !important;
  }

  :global(.swiper-scrollbar) {
    transform: translate3d(0, 0, 10px);
  }

  :global(#desktop-layout .swiper .swiper-scrollbar) {
    height: 20px !important;
    cursor: pointer;
  }
</style>
